export default "__VITE_ASSET__4ybX25aq__"